// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_legal-compliance.scss
// module id = 48
// module chunks = 0